import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";
import { useSession } from "@/stores/session";
import { Shell } from "@/components/layout/shell";

export const Route = createFileRoute("/_authed")({
  beforeLoad: async () => {
    const s = useSession.getState();
    if (!s.hydrated) {
      try { await s.hydrate(); } catch { /* handled below */ }
    }
    if (!useSession.getState().user) {
      throw redirect({ to: "/login" });
    }
  },
  component: AuthedLayout,
});

export function AuthedLayout() {
  const user = useSession((s) => s.user);
  // Re-check on client — defensive if the token expires between navigations.
  useEffect(() => {
    if (!user) return;
    // Poll /me every 5 minutes to detect server-side revocation.
    const id = setInterval(() => void useSession.getState().hydrate(), 5 * 60_000);
    return () => clearInterval(id);
  }, [user]);
  return <Shell />;
}
